module.exports = __webpack_public_path__ + "static/media/close.133d85ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/close.svg
// module id = 1694
// module chunks = 0